import React, { useCallback, useMemo, useState } from "react";
import { SbTableStyled } from "./SbTable.styles";
import { applyColumnFilters, controlUnwiredFilters, markOpenFilterColumn } from "./columnFilters";

// Every column gets a searchable filter by default (see columnFilters.js).
// Pass autoFilters={false} for server-paginated tables, where dataSource holds
// only the current page.
const SbTable = ({
  columns,
  dataSource,
  loading,
  pagination,
  rowKey,
  expandable,
  rowClassName,
  onRow,
  autoFilters = true,
  onChange,
  ...rest
}) => {
  const finalPagination =
    pagination === false
      ? false
      : {
          defaultPageSize: 20,
          pageSizeOptions: ["10", "20", "30"],
          showSizeChanger: true,
          ...pagination,
        };

  const childrenColumnName = expandable?.childrenColumnName;
  // Filter state for columns the page didn't wire up in a controlled table
  // (see controlUnwiredFilters). Unused when the table is uncontrolled.
  const [unwiredFilters, setUnwiredFilters] = useState({});
  // The column whose filter dropdown is open: its header is shown darker (markOpenFilterColumn)
  const [openFilterKey, setOpenFilterKey] = useState(null);
  const handleFilterOpenChange = useCallback(
    (key, open) => setOpenFilterKey((prev) => (open ? key : prev === key ? null : prev)),
    []
  );
  const finalColumns = useMemo(
    () =>
      markOpenFilterColumn(
        controlUnwiredFilters(
          applyColumnFilters(columns, dataSource, { autoFilters, childrenColumnName }),
          unwiredFilters
        ),
        openFilterKey,
        handleFilterOpenChange
      ),
    [columns, dataSource, autoFilters, childrenColumnName, unwiredFilters, openFilterKey, handleFilterOpenChange]
  );

  const handleChange = useCallback(
    (pagination, filters, sorter, extra) => {
      setUnwiredFilters(filters || {});
      onChange?.(pagination, filters, sorter, extra);
    },
    [onChange]
  );

  return (
    <SbTableStyled
      columns={finalColumns}
      dataSource={dataSource}
      loading={loading}
      pagination={finalPagination}
      rowKey={rowKey}
      expandable={expandable}
      rowClassName={rowClassName}
      onRow={onRow}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default SbTable;
